export const GET_CUSTOMER = 'GET_CUSTOMER';

export default {
  GET_CUSTOMER,
};



// WEBPACK FOOTER //
// ./src/store/modules/customer/mutation-types.js